import { z } from "zod";

import { WORKFLOW_RESULT, WORKFLOW_TYPE } from "../../constants";
import { WORKFLOW_HISTORY_TAB_VALUES } from "./constants";

export const WORKFLOW_HISTORY_TAB_QUERY_PARAM = "workflow_type";

const workflowHistoryTabSchema = z.enum(WORKFLOW_HISTORY_TAB_VALUES);

const statusSchema = z.enum(WORKFLOW_RESULT);

const optionalTextSearchParam = z
  .union([z.string(), z.number()])
  .optional()
  .catch(undefined);

export const workflowHistorySearchSchema = z.object({
  workflow_type: workflowHistoryTabSchema.catch(WORKFLOW_TYPE.DYNAMIC),
  page: z.number().int().min(1).catch(1),
  workflow_name: optionalTextSearchParam,
  status: statusSchema.optional().catch(undefined),
  run_id: optionalTextSearchParam,
  run_at_filter_type: optionalTextSearchParam,
  run_at_value: optionalTextSearchParam,
  member_id: z.number().optional().catch(undefined),
  contact_sqid: z.string().optional().catch(undefined),
});

export type WorkflowHistorySearch = z.infer<typeof workflowHistorySearchSchema>;
